/* BHALLO — animacao de contagem pra numeros [data-countup].
   Sobe de 0 ate o numero REAL que voce colocou (nada de crescimento falso).
   Anima so quando entra na tela; respeita quem pediu menos animacao. */
(function () {
  function fmt(n) {
    // separador de milhar em pt-BR (1.200)
    return Math.round(n).toLocaleString('pt-BR');
  }

  function alvo(el) {
    var digitos = (el.getAttribute('data-countup') || '').replace(/[^\d]/g, '');
    return parseInt(digitos, 10) || 0;
  }

  function animar(el) {
    var fim = alvo(el);
    if (!fim) return;

    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduz) { el.textContent = fmt(fim); return; }

    var dur = 1200;
    var inicio = null;
    function passo(ts) {
      if (inicio === null) inicio = ts;
      var p = Math.min((ts - inicio) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(fim * eased);
      if (p < 1) requestAnimationFrame(passo);
      else el.textContent = fmt(fim);
    }
    requestAnimationFrame(passo);
  }

  function init() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;

    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // zera antes de observar (o bloco fica embaixo, entao ninguem ve o 0)
    if (!reduz) {
      for (var i = 0; i < els.length; i++) els[i].textContent = '0';
    }

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < els.length; j++) animar(els[j]);
      return;
    }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });

    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
